/**
 * Sanitizes a single string value against CSV formula injection (CWE-1236).
 * Prefixes with a single quote if the value starts with a formula-triggering character.
 */
const FORMULA_CHARS = ['=', '+', '-', '@', '\t', '\r'];

export function sanitizeCsvValue(value) {
    if (typeof value !== 'string' || value.length === 0) {
        return value;
    }
    if (FORMULA_CHARS.indexOf(value[0]) >= 0) {
        return "'" + value;
    }
    return value;
}

/**
 * Sanitizes all string fields in an array of data objects for safe CSV export.
 */
export function sanitizeCsvData(data) {
    if (!Array.isArray(data)) {
        return data;
    }
    return data.map(row => {
        const sanitized = {};
        for (const key in row) {
            if (Object.prototype.hasOwnProperty.call(row, key)) {
                sanitized[key] = sanitizeCsvValue(row[key]);
            }
        }
        return sanitized;
    });
}
